import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Column, Row, Switch, Typography, useOverlayContext } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { DisableSalesTaxModal } from '../DisableSalesTaxModal/DisableSalesTaxModal';
export const EnableToggleCard = (param)=>{
    let { enabled, onChange } = param;
    const { t } = useLocaleKeys('pages.salesTaxSettings.enableCard');
    const { showModal } = useOverlayContext();
    const handleToggle = (_event, nextChecked)=>{
        if (nextChecked) {
            onChange(true);
            return;
        }
        void showModal({
            biName: 'sales_tax_disable_modal',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(DisableSalesTaxModal, {
                    dismissModal: dismissModal,
                    onConfirm: ()=>onChange(false)
                });
            }
        });
    };
    return /*#__PURE__*/ _jsx(Card, {
        bi: {
            name: 'sales_tax_enable_card'
        },
        autoHeight: true,
        borderRadius: "m",
        children: /*#__PURE__*/ _jsxs(Row, {
            padding: 24,
            justifyContent: "space-between",
            alignItems: "center",
            gap: 24,
            children: [
                /*#__PURE__*/ _jsxs(Column, {
                    gap: 4,
                    style: {
                        flex: 1
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "h6",
                            weight: "normal",
                            children: t.title()
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            skin: "secondary",
                            children: t.description()
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Switch, {
                    bi: {
                        name: 'sales_tax_enable_toggle'
                    },
                    checked: enabled,
                    onChange: handleToggle
                })
            ]
        })
    });
};
